import {
  SET_ALL_COUNTRIES,
  SET_BUNDLES,
  // eslint-disable-next-line prettier/prettier
  SET_TOP_SERVICE_IN_VAS,
  SET_IS_ELIGIBLE_FOR_NEW_GIFTING,
  SET_BUNDLE_GIFTING_DEST_MSISDN,
  SET_PLUS_ELIGIBLE,
  SET_COMBO_PRODUCTS,
  SET_COUNTRY_BUNDLES_V2,
  SET_GROUPS,
} from './actionTypes'

const initialState = {
  bundleData: [],
  countriesData: {},
  topService: {},
  isEligibleForNewGifting: {},
  BundleGiftingDestMsisdn: null,
  isPlusEligible: {},
  comboProducts:{},
  countryBundlesV2: {},
  groupsData: {}
}

const bundleInfo = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BUNDLES:
      return {
        ...state,
        bundleData: payload,
      }
    case SET_ALL_COUNTRIES:
      return {
        ...state,
        countriesData: payload,
      }
    case SET_TOP_SERVICE_IN_VAS:
      return {
        ...state,
        topService: payload,
      }
    case SET_IS_ELIGIBLE_FOR_NEW_GIFTING:
      return {
        ...state,
        isEligibleForNewGifting: payload,
      }
    case SET_BUNDLE_GIFTING_DEST_MSISDN:
      return {
        ...state,
        BundleGiftingDestMsisdn: payload,
      }
    case SET_PLUS_ELIGIBLE:
      return {
        ...state,
        isPlusEligible: payload,
      }
    case SET_COMBO_PRODUCTS:
      return {
        ...state,
        comboProducts: payload,
      }
    case SET_COUNTRY_BUNDLES_V2:
      return {
        ...state,
        countryBundlesV2: payload,
      }
    case SET_GROUPS:
      return {
        ...state,
        groupsData: payload,
      }

    default:
      return state
  }
}

export default bundleInfo
